import { GetCodeListResponse } from "src/app/commons/kymw02/api-services/get-code-list.service";
import { PlessViewUtilsSub } from './../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW7402Component } from "./kymw7402.component";
import { GetRememberGoodsInfoResponce } from "./api-services/get-remember-goods-info.service";
import { GetFixedOrderListResponse } from "./api-services/get-fixed-order-list.service";
import { DetailInfoModel } from "./vo/detail-Info.model";

export class KYMW7402Model {
  kymw7402Componet: KYMW7402Component;

  /** 承認ユーザの権限セットIDリスト */ 
  authoritySetIdList: Array<any> = new Array<any>();
  /**  承認ユーザフラグ */
  authorizedUserFlag: boolean = <boolean>false;

  // 基本情報
  /** 忘れず注文コードID */
  rememberGoodsId: string = <string>'';
  /** アイテムコード */
  itemCode: string = <string>'';
  /** 忘れず注文商品ステータス 
   * 空欄、 1:承認待、2:承認済 */
  rememberGoodsStatus: string = <string>'';
  /** 商品マスタ単価 */
  masterPrice: string = <string>'';
  /** 商品案内用商品名 */
  guideGoodsName: string = <string>'';
  /** 商品案内用規格名 */
  guideStandardName: string = <string>'';
  /** 注文コード */
  orderNum: string = <string>'';
  /** 注文数変更用注文コード */
  orderChangeOrderNum: string = <string>'';
  /** 増量商品 
   * '0': false '1': true */
  increaseGoods: boolean = <boolean>false;
  /** 忘れず注文商品カテゴリコード */
  rememberCategoryCode: string = <string>'';
  /** 受注受付開始企画回 */
  orderReceptionStartCatalog: string = <string>'';
  /** 受注受付終了企画回 */
  orderReceptionEndCatalog: string = <string>'';
  /** 配達開始企画回 */
  deliveryStartCatalog: string = <string>'';
  /** 配達終了企画回 */
  deliveryEndCatalog: string = <string>'';
  /** 配達サイクル区分 */
  deliveryCycleDiv: string = <string>'';
  /** 月毎配達回 */
  monthlyDeliveryTimes: string = <string>'';
  /** 商品企画担当区分 */
  goodsCatalogDiv: string = <string>'';
  /** 休止グループコード */
  pauseGroupCode: string = <string>'';
  /** 生協コード */
  coopCodeList: Array<any> = new Array<any>();
  chk_all: boolean = <boolean>false;

  // 価格情報
  /** 価格情報リスト */
  detailInfoList: Array<DetailInfoModel> = new Array<DetailInfoModel>();
  /** 適用開始企画回 */
  applicableStartCatalog: string = <string>'';
  /** 適用終了企画回 */
  applicableEndCatalog: string = <string>'';
  /** 配達休止フラグ 
   * '0': false '1': true */
  pauseDelivery: boolean = <boolean>false;
  /** 値引区分 
   * 0:値引きなし　1:単価指定　2:率指定 
   * 初期値 0:値引きなし　*/
  discountType: string = <string>'0';
  /** 値引単価 */
  discountUnitPrice: string = <string>'';
  /** 値引率 */
  discountRate: string = <string>'';
  /** 値引き後供給単価 */
  discountPrice: string = <string>'';
  /** 専用商品名 */
  rememberGoodsName: string = <string>'';
  /** 専用商品名(カナ) */
  rememberGoodsNameKana: string = <string>'';
  /** 専用規格名 */
  rememberStandardName: string = <string>'';
  /** 専用規格名(カナ) */
  rememberStandardNameKana: string = <string>'';

  /** 編集フラグ */
  editFlag: boolean = <boolean>true;

  /** 企画確定受注コードリスト */
  fixedOrderList: Array<any> = new Array<any>();

  /** 企画進捗管理最古企画情報 */
  oldCatalogProgressCatalogInfo = {
    orderCode: "",
    catalogId: ""
  };

  /** 企画回リスト */
  readonly orderList: Array<any> = new Array<any>();

  readonly categoryCodeList: Array<any> = new Array<any>();

  /** 忘れず注文商品一覧画面の検索条件を保持するためのパラメータ */
  public searchFlg: boolean = false;
  public searchOrderReceptionCatalog: string = <string>'';
  public searchClassCode: string = <string>'';
  public searchPCode: string = <string>'';
  public searchDeliveryCatalog: string = <string>'';
  public searchBuyerCode: string = <string>'';
  public searchGuideGoodsName: string = <string>'';
  public searchOrderNum: string = <string>'';
  public searchItemCode: string = <string>'';
  public searchGuideStandardName: string = <string>'';
  
  /**
   * 企画確定受注コード一覧取得
   * 
   * @param data 
   */
  public setFixedOrderList(data: GetFixedOrderListResponse) {
    if ( Array.isArray(data) ) {
      this.fixedOrderList = data;
    }
  }

  /**
   * 忘れず注文商品情報取得
   * 
   * @param data 
   */
  public setRememberGoodsInfo(data: GetRememberGoodsInfoResponce) {
    this.rememberGoodsId = data.RememberGoodsId;
    this.itemCode = data.ItemCode;
    this.rememberGoodsStatus = data.RememberGoodsStatus;
    this.masterPrice = data.MasterPrice;
    this.guideGoodsName = data.GuideGoodsName;
    this.guideStandardName = data.GuideStandardName;
    this.orderNum = data.OrderNum;
    this.orderChangeOrderNum = data.OrderChangeOrderNum;
    if (!PlessViewUtilsSub.isEmpty(data.IncreaseGoods) && data.IncreaseGoods === '1') {
      this.increaseGoods = true;
    } else {
      this.increaseGoods = false;
    }
    this.rememberCategoryCode = data.RememberCategoryCode;
    this.kymw7402Componet.cmb_RememberCategoryCode.setCodeValue(this.rememberCategoryCode);
    this.orderReceptionStartCatalog = data.OrderReceptionStartCatalog;
    this.orderReceptionEndCatalog = data.OrderReceptionEndCatalog;
    this.deliveryStartCatalog = data.DeliveryStartCatalog;
    this.deliveryEndCatalog = data.DeliveryEndCatalog;
    this.deliveryCycleDiv = data.DeliveryCycleDiv;
    this.kymw7402Componet.cmb_DeliveryCycleDiv.setCodeValue(data.DeliveryCycleDiv);
    this.monthlyDeliveryTimes = data.MonthlyDeliveryTimes;
    this.goodsCatalogDiv = data.GoodsCatalogDiv;
    this.kymw7402Componet.cmb_GoodsCatalogDiv.setCodeValue(data.GoodsCatalogDiv)
    this.pauseGroupCode = data.PauseGroupCode;

    // 利用生協
    this.coopCodeList = data.CoopCodeList;
    this.kymw7402Componet.setGoodsCoopCheckBoxChecked(this.coopCodeList);

    // 価格情報一覧
    const tempList = [];
    if ( data.DetailInfoList instanceof Array ) {
      data.DetailInfoList.forEach(data => {
        const tempInfo: DetailInfoModel = new DetailInfoModel();
        tempInfo.applicableStartCatalog = data.ApplicableStartCatalog;
        tempInfo.applicableEndCatalog = data.ApplicableEndCatalog;
        // 1の時true, 0の時false
        tempInfo.pauseDelivery = data.PauseDelivery;
        tempInfo.discountType = data.DiscountType;
        tempInfo.discountUnitPrice = data.DiscountUnitPrice;
        tempInfo.discountRate = data.DiscountRate;
        tempInfo.rememberGoodsName = data.RememberGoodsName;
        tempInfo.rememberGoodsNameKana = data.RememberGoodsNameKana;
        tempInfo.rememberStandardName = data.RememberStandardName;
        tempInfo.rememberStandardNameKana = data.RememberStandardNameKana;
        tempList.push(tempInfo);
      })
      this.detailInfoList = tempList;
    }
  }
}